import PDFViewer from './PDFViewer';
import { toast } from 'react-toastify';

export const PdfWindowViewer = () => {
  const params = new URLSearchParams(window.location.search);
  const data = params.get('data');
  let fileName = '', pdfUrl = '', pageNumber = 1;
  if (data) {
    try {
      const decoded = JSON.parse(decodeURIComponent(atob(data)));
      fileName = decoded.fileName;
      pdfUrl = decoded.pdfUrl;
      pageNumber = decoded.pageNumber;
    } catch (e) {
      toast.error('Invalid or corrupted PDF link. Please try again.');
      console.error('Error decoding PDF data:', e);
    }
  }else {
    toast.error('No PDF data found in the URL.');
  }

  return (
    <PDFViewer
      fileName={fileName}
      pdfUrl={pdfUrl}
      pageNumber={pageNumber}
      open={true}
      onClose={() => window.close()}
    />
  );
};